import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { bulkDeleteMaterialVolumetricPricesApi } from "#modules/materials/infra/bulkDeleteMaterialVolumetricPrices.api";
import { materialsVolumetricPriceQuery } from "#modules/materials/infra/materialsVolumetricPrice.query";

export const useBulkDeleteMaterialVolumetricPrices = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: bulkDeleteMaterialVolumetricPricesApi,
    onError: (err: Error) => {
      showErrorToast({ title: err.message });
      errorHandler(err);
    },
    onSettled: () => {
      void queryClient.invalidateQueries(materialsVolumetricPriceQuery());
    },
  });

  return { bulkDeleteMaterialVolumetricPrices: mutate, ...rest };
};
